<div *ngIf="!isConfirmation">
    <div class="modal-header bg-{{class}} d-flex align-items-center" style="padding: 8px 10px">
        <h3 class="modal-title text-center text-white m-0">
            <i class="{{iconClass}} mx-3"></i> {{messageType}}
        </h3>
    </div>
    <div class="modal-body text-center">
        <p style="margin: 0; font-size: 1.3rem">{{message}}</p>
    </div>
    <div class="modal-footer text-right" style="padding: 2px">
        <button class="btn btn-sm btn-rounded btn-{{class}}" (click)="close()">Close</button>
    </div>
</div>

<div *ngIf="isConfirmation">
    <div class="modal-header bg-{{class}} d-flex align-items-center" style="padding: 8px 10px">
        <h3 class="modal-title text-center text-white m-0">
            <i class="{{iconClass}} mx-3"></i> {{messageType}}
        </h3>
    </div>
    <div class="modal-body text-center">
        <p style="margin: 0; font-size: 1.3rem">{{message}}</p>
    </div>
    <div class="modal-footer text-right" style="padding: 3px">
        <button class="btn btn-sm btn-rounded btn-secondary" (click)="close()" >Cancel</button>
        <button class="btn btn-sm btn-rounded btn-{{class}}" (click)="confirm()" >Confirm</button>
    </div>
</div>
